import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getLands: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS].GET_LANDS,
	},
	getBaseLands: {
		useCache: true,
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS].GET_LANDS,
	},
	getExtendLands: {
		useCache: true,
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS].GET_LANDS,
	},
	getLand: {
		useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS].GET_LAND,
	},
	createLand: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS].CREATE_LAND,
	},
	putLand: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS].PUT_LAND,
	},
	patchLand: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS].PATCH_LAND,
	},
	deleteLand: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS].DELETE_LAND,
	},
	getLandPreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS].GET_LAND_PREVIEW,
	},
	getLandPopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS].GET_LAND_POPUP,
	},
}
